import * as React from 'react'
import { Modal, ModalProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'i18n'

type Props = {
  options: string[]
  cancel: boolean
  onClose: React.MouseEventHandler
  onClick: (index: number) => void
} & Omit<ModalProps, 'children'>

const Component: React.FC<Props> = ({
  options = [],
  cancel,
  onClose,
  onClick = null,
  ...props
}) => {
  const { t } = useTranslation('components')
  const s = useStyle({})

  return (
    <Modal {...props} onClose={onClose}>
      <div className={s.paper}>
        <div className={s.content}>
          {options.map((option, i) => (
            <button
              key={i}
              className={s.button}
              onClick={e => {
                e.stopPropagation()
                onClick.bind(this, i)(e)
              }}
            >
              {option}
            </button>
          ))}
          {cancel && (
            <button onClick={onClose} className={s.button}>
              {t('ActionSheet.index.cancel')}
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

const useStyle = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
  },
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translateY(-50%) translateX(-50%)',
    borderRadius: 10,
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
    overflow: 'hidden',
  },
  button: {
    '&:active': {
      backgroundColor: '#EEE',
    },
    width: '100%',
    fontSize: 16,
    fontWeight: 700,
    padding: '10px 0',
    borderBottom: '1px solid #d1d3d6',
    backgroundColor: '#FFF',
  },
}))

export default Component
